
import { storage } from '../lib/storage';
import { Store, StoreBranding } from '../types';

/**
 * StoreService: Lynqar ke Multi-Store architecture ka core.
 * Ye handle karta hai store discovery, branding resolution, aur vendor settings.
 */
export const storeService = {
  /**
   * Sare active stores fetch karna marketplace ke liye.
   */
  getPublicStores: (): Store[] => {
    return storage.getStores().filter(s => s.status === 'ACTIVE');
  },

  /**
   * Slug (URL part) ke zariye store ki info nikalna.
   * E.g. lynqar.com/store/gadget-hub -> 'gadget-hub' is the slug.
   */
  getStoreBySlug: (slug: string): Store | null => {
    const stores = storage.getStores();
    return stores.find(s => s.slug === slug) || null;
  },

  /**
   * Store ID ke zariye configuration fetch karna (Admin usage).
   */
  getStoreById: (id: string): Store | null => {
    return storage.getStores().find(s => s.id === id) || null;
  },

  /**
   * Store ka look and feel (Branding) update karna.
   * Ye future me 'Dynamic Theme Engine' ko power karega.
   */
  updateBranding: async (storeId: string, newBranding: Partial<StoreBranding>): Promise<boolean> => {
    const store = storage.getStoreConfig(storeId);
    if (!store) return false;

    const updatedStore: Store = {
      ...store,
      branding: {
        ...store.branding,
        ...newBranding
      } as StoreBranding
    };

    storage.saveStoreConfig(updatedStore);
    
    // Custom event fire karna taaki UI bina refresh hue update ho jaye
    window.dispatchEvent(new Event('store-branding-update'));
    return true;
  },

  /**
   * Check karna ki store active hai ya nahi (Security check).
   */
  isStoreOperational: (storeId: string): boolean => {
    const store = storage.getStoreConfig(storeId);
    return store?.status === 'ACTIVE';
  }
};
